angular
    .module("skillBuilderSaaS")
    .directive("learningPath", function () {
    return {
        scope: {
            connectionOptionsTemplate: "@",
            ngModel: "=",
            readonly: "=",
            newversion: "=",
            sortable: "=",
            onItemClick: "&",
            onRecognitionClick: "&",
            onInformationClick: "&",
            onInformationEnabledClick: "&",
            //onHasCertificateClick: "&",
            search: "="
        },
        required: "ngModel",
        restrict: "A",
        templateUrl: function (_elem, attrs) {
            return attrs.templateUrl || "app/templates/learningPathTemplate.html";
        },
        controller: ["colorService", "$element", "$localStorage", "$rootScope", "$scope", "$templateRequest", "$window", "$timeout", "_",
            function (colorService, $element, $localStorage, $rootScope, $scope, $templateRequest, $window, $timeout, _) {
                var learningPathCtrlVm = this;
                var oldResize = $window.onresize;
                learningPathCtrlVm.isDragging = false;
                learningPathCtrlVm.readonly = function () {
                    if ($scope.readonly !== undefined)
                        return $scope.readonly;
                    return true;
                };
                learningPathCtrlVm.newversion = function () {
                    if ($scope.newversion !== undefined)
                        return $scope.newversion;
                    return true;
                };
                learningPathCtrlVm.filter = function (name) {
                    if (!$scope.search)
                        return true;
                    var search = $scope.search;
                    //Escape invalid characters
                    search = search.replace(new RegExp("(\\" + ["/", ".", "*", "+", "?", "|", "(", ")", "[", "]", "{", "}", "\\", "$", "^", "-"].join("|\\") + ")", "g"), "\\$1");
                    //Preserve words inside quotes as single words
                    var words = $.map(search.match(/"[^"]+"|[^ ]+/g) || [""], function (word) {
                        if (word.charAt(0) === "\"") {
                            var m = word.match(/^"(.*)"$/);
                            word = m ? m[1] : word;
                        }
                        return word.replace("\"", "");
                    });
                    search = "^(?=.*?" + words.join(")|(?=.*?") + ").*$";
                    return new RegExp(search, "ig").test(name);
                };
                learningPathCtrlVm.pathSortableOptions = {
                    disabled: learningPathCtrlVm.readonly()
                };
                if ($scope.sortable) {
                    learningPathCtrlVm.pathSortableOptions.placeholder = $scope.sortable.placeholder;
                    learningPathCtrlVm.pathSortableOptions["ui-floating"] = $scope.sortable["ui-floating"];
                    learningPathCtrlVm.pathSortableOptions.forcePlaceholderSize = $scope.sortable.forcePlaceholderSize;
                    learningPathCtrlVm.pathSortableOptions.tolerance = $scope.sortable.tolerance;
                    learningPathCtrlVm.pathSortableOptions.dropOnEmpty = $scope.sortable.dropOnEmpty;
                    learningPathCtrlVm.pathSortableOptions.disabled = learningPathCtrlVm.readonly();
                    learningPathCtrlVm.pathSortableOptions.start = function (e, ui) {
                        learningPathCtrlVm.isDragging = true;
                        learningPathCtrlVm.deleteConnections(ui.item.sortable.model);
                        if ($scope.sortable.start)
                            $scope.sortable.start(e, ui);
                    };
                    learningPathCtrlVm.pathSortableOptions.update = function (e, ui) {
                        var dropIndex = angular.copy(ui.item.sortable.dropindex);
                        $timeout(function () {
                            var item = learningPathCtrlVm.getByOrder(dropIndex);
                            if (item)
                                learningPathCtrlVm.deleteSourceConnections(item);
                        });
                        if ($scope.sortable.update)
                            $scope.sortable.update(e, ui);
                    };
                    learningPathCtrlVm.pathSortableOptions.stop = function (e, ui) {
                        learningPathCtrlVm.isDragging = false;
                        if ($scope.sortable.stop)
                            $scope.sortable.stop(e, ui);
                        learningPathCtrlVm.refresh();
                    };
                    learningPathCtrlVm.pathSortableOptions.items = ".learning-item-wrapper";
                    learningPathCtrlVm.pathSortableOptions.cancel = ["jsplumb-source", $scope.sortable.cancel];
                }
                learningPathCtrlVm.mouseMove = function () {
                    if (learningPathCtrlVm.isDragging)
                        learningPathCtrlVm.refresh();
                };
                learningPathCtrlVm.container = $element;
                learningPathCtrlVm.connectionOverlays = [["Arrow", {
                            location: 1,
                            id: "arrow",
                            length: 10,
                            foldback: 1
                        }]];
                if ($scope.connectionOptionsTemplate) {
                    $templateRequest($scope.connectionOptionsTemplate).then(function (template) {
                        learningPathCtrlVm.connectionOverlays.push(["Custom", {
                                create: function () {
                                    return angular.element(template);
                                },
                                location: 0.5, id: "connectionOptions"
                            }]);
                    });
                }
                learningPathCtrlVm.deleteConnection = function (connection) {
                    learningPathCtrlVm.instance.detach(connection);
                    learningPathCtrlVm.refresh();
                };
                learningPathCtrlVm.deleteConnections = function (item, removeEndpoints) {
                    var next = learningPathCtrlVm.getByOrder(item.order + 1);
                    if (next) {
                        next.preReqItemId = null;
                        next.required = false;
                    }
                    item.preReqItemId = null;
                    item.required = false;
                    var connections = learningPathCtrlVm.instance.getConnections({ source: "item-source-" + item.itemId })
                        .concat(learningPathCtrlVm.instance.getConnections({ target: "item-target-" + item.itemId }));
                    for (var i = 0; i < connections.length; i++) {
                        learningPathCtrlVm.instance.detach(connections[i]);
                    }
                    if (removeEndpoints) {
                        learningPathCtrlVm.instance.remove("item-source-" + item.itemId);
                        learningPathCtrlVm.instance.remove("item-target-" + item.itemId);
                    }
                    learningPathCtrlVm.refresh();
                };
                learningPathCtrlVm.deleteSourceConnections = function (item) {
                    var next = learningPathCtrlVm.getByOrder(item.order + 1);
                    if (next) {
                        next.preReqItemId = null;
                        next.required = false;
                    }
                    var connections = learningPathCtrlVm.instance.getConnections({ source: "item-source-" + item.itemId });
                    for (var i = 0; i < connections.length; i++) {
                        learningPathCtrlVm.instance.detach(connections[i]);
                    }
                    learningPathCtrlVm.refresh();
                };
                learningPathCtrlVm.hasTargetConnections = function (item) {
                    var connections = learningPathCtrlVm.instance.getConnections({ target: "item-target-" + item.itemId });
                    return connections.length > 0;
                };
                learningPathCtrlVm.refresh = function () {
                    $timeout(function () {
                        learningPathCtrlVm.instance.recalculateOffsets(learningPathCtrlVm.container);
                        learningPathCtrlVm.instance.repaintEverything();
                    }, 100);
                };
                learningPathCtrlVm.removeItem = function (item) {
                    var next = learningPathCtrlVm.getByOrder(item.order + 1);
                    if (next) {
                        next.preReqItemId = null;
                        next.required = false;
                    }
                    learningPathCtrlVm.deleteConnections(item, true);
                    $scope.ngModel.items = recalculateOrder(_.without($scope.ngModel.items, item));
                    learningPathCtrlVm.refresh();
                };
                learningPathCtrlVm.getByOrder = function (order) {
                    return _.find($scope.ngModel.items, { order: order });
                };
                learningPathCtrlVm.getByItemId = function (itemId) {
                    return _.find($scope.ngModel.items, { itemId: itemId });
                };
                learningPathCtrlVm.itemClick = function (item) {
                    if ($scope.onItemClick)
                        $scope.onItemClick({ item: item });
                };
                learningPathCtrlVm.informationClick = function (path) {
                    if ($scope.onInformationClick)
                        $scope.onInformationClick({ path: path });
                };
                learningPathCtrlVm.informationEnabledClick = function (isInformationEnabled) {
                    if ($scope.onInformationEnabledClick)
                        $scope.onInformationEnabledClick({ isInformationEnabled: isInformationEnabled });
                };
                learningPathCtrlVm.recognitionClick = function (path) {
                    if ($scope.onRecognitionClick)
                        $scope.onRecognitionClick({ path: path });
                };
                //learningPathCtrlVm.hasCertificateClick = function (enabled) {
                //	if ($scope.onHasCertificateClick)
                //		$scope.onHasCertificateClick({ enabled: enabled });
                //};
                $timeout(function () {
                    $window.jsPlumb.ready(function () {
                        learningPathCtrlVm.instance = $window.jsPlumb.getInstance({
                            Connector: ["Flowchart"],
                            Container: learningPathCtrlVm.container,
                            ConnectionOverlays: learningPathCtrlVm.connectionOverlays
                        });
                        learningPathCtrlVm.instance.registerConnectionTypes({
                            "required": {
                                paintStyle: { strokeStyle: $localStorage.tenantSettings.primaryColor /* colorService.getPrimaryColor()*/, lineWidth: 2, dashstyle: "0" },
                                hoverPaintStyle: { strokeStyle: $localStorage.tenantSettings.primaryColor /*colorService.getPrimaryColor()*/ },
                                cssClass: "connector-required"
                            },
                            "recommended": {
                                paintStyle: { strokeStyle: $localStorage.tenantSettings.primaryColor /*colorService.getPrimaryColor()*/, lineWidth: 2, dashstyle: "2 2" },
                                hoverPaintStyle: { strokeStyle: $localStorage.tenantSettings.primaryColor /*colorService.getPrimaryColor()*/ },
                                cssClass: "connector-recommended"
                            }
                        });
                    });
                });
                $window.onresize = function () {
                    if (typeof oldResize === "function") {
                        oldResize();
                    }
                    learningPathCtrlVm.refresh();
                };
                //2024-04-12 remove minified version of menu
                //$rootScope.$on("ContentSizeChanged", function () {
                //	learningPathCtrlVm.refresh();
                //});
                this.$onDestroy = function () {
                    $window.onresize = oldResize;
                };
                function recalculateOrder(list) {
                    return _.map(list, function (item, key) {
                        item.order = key + 1;
                        return item;
                    });
                }
                $scope.$watch("readonly", function (newValue) {
                    learningPathCtrlVm.pathSortableOptions.disabled = newValue === undefined ? true : newValue;
                    learningPathCtrlVm.refresh();
                });
            }],
        controllerAs: "learningPathCtrlVm"
    };
})
    .directive("learningItem", function () {
    return {
        scope: {
            ngModel: "="
        },
        restrict: "AE",
        require: ["^^learningPath", "ngModel"],
        transclude: true,
        template: "<div ng-transclude></div>",
        controller: ["$compile", "$element", "$scope", "$timeout",
            function ($compile, _$element, $scope, $timeout) {
                var nodeCtrl = this;
                nodeCtrl.connection = {};
                var learningPathScope = $scope.$parent.$parent;
                var learningPathCtrlVm = learningPathScope.learningPathCtrlVm;
                nodeCtrl.model = $scope.ngModel;
                nodeCtrl.connect = function (nodeModel) {
                    $timeout(function () {
                        if (learningPathCtrlVm.hasTargetConnections(nodeModel))
                            return;
                        if (nodeModel.preReqItemId) {
                            nodeCtrl.connection = learningPathCtrlVm.instance.connect({
                                source: "item-source-" + nodeModel.preReqItemId,
                                target: "item-target-" + nodeModel.itemId,
                                connectorOverlays: learningPathCtrlVm.connectionOverlays,
                                type: nodeModel.required ? "required" : "recommended",
                                anchors: ["Right", "Left"],
                                endpoint: "Blank",
                                deleteEndpointsOnDetach: false,
                                maxConnections: 1
                            });
                            if (nodeCtrl.connection) {
                                nodeCtrl.targetId = nodeModel.itemId;
                                var overlays = nodeCtrl.connection.getOverlays();
                                if (overlays && overlays.connectionOptions) {
                                    $compile(nodeCtrl.connection.getOverlays().connectionOptions.canvas)($scope);
                                }
                            }
                        }
                    });
                };
                nodeCtrl.connect(nodeCtrl.model);
                nodeCtrl.setRequired = function () {
                    var targetNode = learningPathCtrlVm.getByItemId(nodeCtrl.targetId);
                    targetNode.required = true;
                    $timeout(function () {
                        nodeCtrl.connection.setType("required");
                    });
                };
                nodeCtrl.setRecommended = function () {
                    var targetNode = learningPathCtrlVm.getByItemId(nodeCtrl.targetId);
                    targetNode.required = false;
                    $timeout(function () {
                        nodeCtrl.connection.setType("recommended");
                    });
                };
                nodeCtrl.removeConnection = function () {
                    var targetNode = learningPathCtrlVm.getByItemId(nodeCtrl.targetId);
                    targetNode.required = false;
                    targetNode.preReqItemId = null;
                    $timeout(function () {
                        learningPathCtrlVm.deleteConnection(nodeCtrl.connection);
                    });
                };
                nodeCtrl.isRequired = function () {
                    if (!nodeCtrl.connection || !nodeCtrl.connection.connector)
                        return false;
                    return nodeCtrl.connection.hasType("required");
                };
                nodeCtrl.showOverlay = function () {
                    return !learningPathCtrlVm.readonly();
                };
            }],
        controllerAs: "nodeCtrl"
    };
})
    .directive("jsplumbSource", function () {
    return {
        scope: false,
        restrict: "AE",
        require: ["^^learningPath", "^learningItem"],
        replace: true,
        link: function (_scope, elem, _attrs, requireCtrl) {
            var learningPathCtrl = requireCtrl[0];
            var nodeCtrl = requireCtrl[1];
            elem.on("click", function () {
                if (learningPathCtrl.readonly())
                    return;
                var nextNode = learningPathCtrl.getByOrder(nodeCtrl.model.order + 1);
                if (nextNode) {
                    nextNode.preReqItemId = nodeCtrl.model.itemId;
                    nextNode.required = true;
                    nodeCtrl.connect(nextNode);
                }
            });
        }
    };
})
    .directive("jsplumbTarget", ["$timeout", function ($timeout) {
        return {
            scope: false,
            restrict: "AE",
            require: "^^learningPath",
            link: function (_scope, elem, _attrs, learningPathCtrl) {
                if (learningPathCtrl.instance) {
                    $timeout(function () {
                        learningPathCtrl.instance.makeTarget(elem, {
                            anchor: "Continuous",
                            endpoint: "Blank",
                            deleteEndpointsOnDetach: false,
                            uniqueEndpoint: true
                        });
                    });
                }
            }
        };
    }]);
